import {LineItemModel} from '../../../../../../domain/models/LineItem.model';
import {DescriptionLineModel} from '../../../../../../domain/models/DescriptionLine.model';
import {MAX_DESCRIPTION_LINE_LENGTH} from '../../../../../constants';

export const mapLineItemToDetails = (
  lineItem: LineItemModel
): {
  descriptionLines?: string[];
} => {
  const options: string[] = lineItem.descriptionLines.map(toDescriptionLineString);
  return {descriptionLines: options};
};

const toDescriptionLineString = (descriptionLine: DescriptionLineModel): string => {
  if (!descriptionLine.title) {
    return trimToMaxLength(descriptionLine.value, MAX_DESCRIPTION_LINE_LENGTH);
  }
  return `${descriptionLine.title}: ${trimToMaxLength(descriptionLine.value, MAX_DESCRIPTION_LINE_LENGTH)}`;
};

export const trimToMaxLength = (value: string, maxLength?: number): string => {
  if (!maxLength || value.length <= maxLength) {
    return value;
  }
  return `${value.slice(0, maxLength - 3)}...`;
};
